<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATEROW  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATEROW>
    <UPDATE  ref="synChildUpdate"  @submit="synSubmit" :updateData="synUpdateData"></UPDATE>
    <UPDATE  ref="serviceChildUpdate"  @submit="serviceSubmit" :updateData="serviceUpdateData"></UPDATE>
    <UPDATE  ref="uploadServiceChildUpdate"  :updateData="uploadServiceUpdateData" @uploadFile="uploadFile"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import UPDATEROW from '@/components/page/updateRow.vue'
  import URL from '@/api/im/url'
  import Qs from 'qs'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import download from '@/utils/download'
  let effect = {1:"有效",2:"无效"}
  let intention = {1:"高",2:"中",3:"低",4:"无"}
  let type = {0:"真实",1:"模拟"}
  let title = {"0081":"先生","0082":"女士","0083":"太太","0084":"小姐"}
  let callTitleList = {}
  let extensionList = {}
  let extensionData = ""
  let callPrefix = {}
  let callPrefixData = ""
  let userList = {}
  let serviceSign = "/my/";
  let activeStatus = {0:"未激活",1:"已激活"}
  let callType = {1:"电话",2:"Zalb",3:"IM"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE,
      UPDATEROW
    },
    mounted() {
      this.dataChanage(URL.call.setting.getListByUser,{},res => {
        if (res.code == 0){
          const arr = res.result;
          for (let i in arr) {
            if (arr[i].type == 1) callTitleList[arr[i].content] = arr[i].content;
            else if (arr[i].type == 2) {
              extensionList[arr[i].content] = arr[i].content;
              extensionData = arr[i].content;
            }else if (arr[i].type == 4) {
              callPrefix[arr[i].content] = arr[i].content;
              callPrefixData = arr[i].content;
            }
          }
          console.log(extensionData,callPrefixData);
          this.updateData.cols.find((col)=>{return col.field == "extension"}).data = extensionData;
          this.updateData.cols.find((col)=>{return col.field == "callPrefix"}).data = callPrefixData;
        }
      })
      this.axios.post(URL.call.customer.getServiceUser,  {pageNum: 1, pageSize: 1000},{headers:{'Content-Type': 'application/json'}}).then(res => {
          //console.log(res);
          if (res.code == 0 && res.result){
            let arr = res.result.list;
            for (let i in arr) {
              userList[arr[i].userName] = arr[i].displayName;
            }
          }
      })
    },
    methods: {
      uploadFile(col,result){
        this.$refs.childTable.defaultGetData(this.queryData);
        //console.log(result)
      },
      checkbox(val){
        this.checkData = val;
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "call"){
          row.callPhone = row.mobilePhone;
          row.activeStatus = (row.activeTime && row.activeTime > 0)?"激活":"未激活";
          row.id = null;
          row.callPhone = callPrefixData + row.mobilePhone;
          row.name = row.englishLastName + " " +row.englishFirstName;
          row.remark = null;
          this.$refs.childUpdate.open(row);
          this.updateData.visible = true;
        }else if(clickName == "setServiceUser"){
          this.$refs.serviceChildUpdate.open(row);
        }else if(clickName == 'callTime'){
          //this.$router.push({path:"/crs36/pushMsg/ceGroupUser",query:{groupId:row.id,label:"CRS36"}});
          this.$router.push({path:"/IM/call/customercall",query:{label:"IM",customerNumber:row.customerNumber}});
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if (clickName == '数据同步'){
          this.$refs.synChildUpdate.open();
        }else if (clickName == '数据导出'){
          const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
          download.exportExcel(URL.call.customer.export,param,"用户数据");
        }else if (clickName == '列段显示/隐藏'){
          this.pageData.isShow = !this.pageData.isShow;
        }else if (clickName == '分配客服'){
          this.$refs.serviceChildUpdate.open();
        }else if (clickName == '上传分配客服'){
          this.$refs.uploadServiceChildUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //console.log(model);
        /*if (!model.id) {
          this.$message.error("通话录音失败");
          return;
        }*/
        //根据是否包含id更新还是添加
        this.dataChanage(URL.call.customercall.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      synSubmit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.call.customer.synCustomer,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.synChildUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      serviceSubmit(model){
        if (model.id){ //单个用户分配客服
          //根据是否包含id更新还是添加
          this.dataChanage(URL.call.customer.setServiceUser,model,res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$refs.serviceChildUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }else if(this.checkData.length > 0){
          let arr = [];
          for (let i in this.checkData) {
             arr.push(this.checkData[i].customerNumber);
          }
          let customerNumbers = arr.join(",");
          //customerNumbers,serviceUserName
          this.dataChanage(URL.call.customer.setServiceUsers,{customerNumbers:customerNumbers,serviceUserName:model.serviceUserName},res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$refs.serviceChildUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        checkData:[],
        queryData:{},
        synUpdateData:{
          modelName:"将此交易账号在PTS的数据同步到IM后台",
          cols:[
            { title: '用户账号', field: 'customerNumber',required:true},
          ]
        },
        serviceUpdateData:{
          modelName:"分配客服",
          cols:[
            { title: 'id', field: 'id',hidden:true},
            { title: '客服账号', field: 'serviceUserName',type:2, optionList: userList,required:true},
          ]
        },
        uploadServiceUpdateData:{
          submit: "hidden",
          modelName:"上传分配客服名单",
          cols:[
            { title: "上传分配客服名单", field: 'file',type:11,action:URL.call.customer.uploadServiceUser,downUrl:"https://static.chwenda.com/source/downloadModel/分配客服名单.xlsx"},
          ]
        },
        /*新增或更新*/
        updateData:{
          class:'customer',
          modelName:"拨打电话",
          canClose:true,
          beforeClose:(done)=>{
            if (this.updateData.canClose) {
              done();
            }else{
              this.$message.error("请先挂断通话");
            }
          },
          cols:[
            { title: 'id', field: 'id',hidden:true},
            { title: 'companyId', field: 'companyId',hidden: true},
            { title: '类型', field: 'type',hidden: true},
            { title: '国籍', field: 'nationality',hidden: true},
            { title: '性别', field: 'title',hidden: true},
            { title: '归属客服', field: 'serviceUserName',hidden: true},
            { title: '英文名', field: 'englishFirstName',readonly:true,hidden: true},
            { title: '英文姓', field: 'englishLastName',readonly:true,hidden: true},
            { title: '姓名', field: 'name',type:17,span:12},
            { title: '用户账号', field: 'customerNumber',type:17,span:12},
            { title: '邮箱', field: 'email',hidden: true},
            { title: '平台', field: 'platform',hidden: true},
            { title: '激活时间', field: 'activeTime',hidden: true},
            { title: '激活状态', field: 'activeStatus',type:17,span:12},
            { title: '跟进次数', field: 'callTime',type:17,span:12},
            { title: '开户时间', field: 'ctime',hidden: true},
            { title: '业务组', field: 'businessType',hidden: true},
            { title: '手机区号', field: 'mobilePhonePrefix',readonly:true,hidden: true},
            { title: '手机号', field: 'mobilePhone',hidden:true},
            { title: '分机号', field: 'extension',type:2,optionList: extensionList,required:true,data:extensionData,span:12},
            { title: '拨打线路', field: 'callPrefix',type:2,optionList: callPrefix,required:true,span:12,change:(model,cols)=>{
                let col = {};
                for (let i in cols){
                  if (cols[i].field == "callPhone") {
                    col = cols[i];
                  }
                }
                this.$set(col,"data",model.callPrefix.startsWith("1")?(model.callPrefix+model.mobilePhone):(""+model.mobilePhone));
              },data:callPrefixData},
            { title: '拨打手机号', field: 'callPhone',required:true,span:12},
            { title:"拨打",type:18,span:12,click:(updateModel,col,cols)=>{
                if (col.title != "挂断") {
                  this.dataChanage(URL.call.customercall.call,{extension:updateModel.extension,callPhone:updateModel.callPhone,callPrefix:updateModel.callPrefix,mobilePhone:updateModel.mobilePhone},res => {
                    console.log(res);
                    if (res.code == 0) {
                      this.$message.success("suc");
                      col.title = "挂断";
                      this.updateData.canClose = false;
                    } else {
                      this.$message.error(res.message);
                    }
                  });
                }else if (col.title == "挂断") {
                  this.dataChanage(URL.call.customercall.hangupAndRecord,updateModel,res => {
                    if (res.code == 0) {
                      for (let i in cols) {
                        if (cols[i].field == "id"){
                          cols[i].data = res.result;
                        }
                      }
                      console.log(updateModel);
                      this.$forceUpdate();
                      this.$message.success("suc");
                    } else {
                      this.$message.error(res.message);
                    }
                    col.title = "重新拨打";
                    this.updateData.canClose = true;

                  },res=>{
                    col.title = "重新拨打";
                    this.updateData.canClose = true;
                  });
                }
              }},
            { title: '联系方式', field: 'callType',type:2,optionList: callType,required:true,data:1,isNumber:true,span:12},
            { title: '通话标题', field: 'callTitle',type:2,optionList: callTitleList,required:true,span:12},
            { title: '是否有效', field: 'effect',type:2,optionList:effect,isNumber:true,required:true,span:12},
            { title: '意向度', field: 'intention',type:2,optionList:intention,isNumber:true,required:true,span:12},
            { title: '备注', field: 'remark',textType:'textarea',position:"textarea",autosize:{minRows:4,maxRows:10}},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '用户账号', field: 'customerNumber'},
            { title: '手机号', field: 'mobilePhone'},
            { title: '邮箱', field: 'email'},
            { title: '类型', field: 'type',type:2,optionList:type},
            { title: '归属客服', field: 'serviceUserName',type:2,optionList:userList,hidden: this.$route.path.indexOf(serviceSign) >= 0},
            { title: '激活状态', field: 'activeStatus',type:2,optionList:activeStatus},
            { title: '开户开始时间', field: 'startCTime',type:5},
            { title: '开户结束时间', field: 'endCTime',type:5},
            { title: '激活开始时间', field: 'startActiveTime',type:5},
            { title: '激活结束时间', field: 'endActiveTime',type:5},
            {title: "serviceType",field: 'serviceType',data:this.$route.path.indexOf(serviceSign) >= 0?2:1,hidden:true},
            {click:"查询",auth:"call.customer.query"},
            {click:"数据同步"},
            {click:"数据导出",auth:"call.customer.export"},
            {click:"分配客服",hidden:this.$route.path.indexOf(serviceSign) >= 0,auth:"call.customer.service"},
            {click:"列段显示/隐藏"},
            {click:"上传分配客服",hidden:this.$route.path.indexOf(serviceSign) >= 0,auth:"call.customer.upload"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.call.customer.list, //请求路径和参数
          selection: true,
          sequence: true,
          isShow: false,
          checkList:[
            '手机号',
            '手机区号',
            '用户账号',
            '姓名',
            '开户时间',
            '激活时间',
            '入金失败时间',
            '平台',
            '跟进内容',
            '类型',
            '归属客服',
            '前一归属客服',
            '通话标题',
            '备注',
          ],
          cols: [
            { title: '手机号', field: 'mobilePhone',h5Click:"call"},
            { title: '手机区号', field: 'mobilePhonePrefix'},
            { title: '用户账号', field: 'customerNumber'},
            { title: '姓名', field: 'englishFirstName',render:(data,full)=>{
              return full.englishLastName + " " + full.englishFirstName;englishFirstName
              }},
            { title: '开户时间', field: 'ctime',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            { title: '激活时间', field: 'activeTime',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            { title: '入金失败时间', field: 'lastCashinFailTime',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            { title: '平台', field: 'platform'},
            { title: '跟进内容', field: 'callTime',h5Click:"callTime",h5ClickRender:(data, full) =>{
              return (data && data > 0);
              }},
           /* { title: '邮箱', field: 'email'},*/
            /*{ title: '业务组', field: 'businessType'},*/
            { title: '类型', field: 'type',render:(data,full)=>{
                return type[data];
              }},
            { title: '归属客服', field: 'serviceUserName',render:(data,full)=>{
                return userList[data];
              }},
            { title: '前一归属客服', field: 'servicePreUserName',render:(data,full)=>{
                return userList[data];
              }},
            { title: '通话标题', field: 'callTitle'},
            { title: '备注', field: 'remark'},
            {title: '操作',width: 200,btnClick:[
                {name: '拨打',click:"call",type:"primary",icon:"el-icon-edit"},
                {name: '跟进',click:"call",type:"primary",icon:"el-icon-edit"},
              ]
            },
          ]
        }
      }
    }
  }
</script>
<style>
.customer .el-form-item{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.customer .textarea{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 6%;
}
.customer .el-form-item__content{
  width: 80%;
}
.customer .newLine .el-form-item__content{
  width: 100%;
}
.customer .el-form-item.newLine{
  flex-wrap: wrap;
  justify-content: flex-start;
}
.customer .newLine .el-form-item__label{
  width: 100%;
  background: #fbfbfb;
  text-align: left;
  padding: 0 15px;
  border: solid 1px #e6e6e6;
}
.customer .el-upload-dragger{width: 200px;}
.customer .el-dialog__footer{
  display: flex;
  justify-content: center;
  align-items: center;
}
#edui_fixedlayer{z-index: 9999999!important;}
.remarkType{
  overflow: hidden;
  margin: -15px 0 22px;
}
.remarkType span{
  overflow: hidden;
  display: block;
  width: 80%;
  float: right;
  padding: 0 10px;
}
</style>
